// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */

import _ from 'lodash';
import { useEffect } from 'react';
import usePrevious from './usePrevious';

function useOnChange(value, callback) {
  const prevValue = usePrevious(value);
  useEffect(() => {
    if (prevValue !== undefined && !_.isEqual(prevValue, value)) {
      callback(prevValue);
    }
  }, [prevValue, value]);
}

export default useOnChange;
